import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

// Components
import { InputField } from "../../../../Components/formElements/InputField";
import toast from "react-hot-toast";

//Serivce
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { useDispatch, useSelector } from "react-redux";
import { getMaterialList } from "../../../../redux/feature/customer_app/customerV1Slice";
import ShowUploadImage from "./ShowUploadImage";
import { formatDateWithAMPM, validateRequired } from "../../../../common/Validations";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import { MultiselectFieldHB } from "../../../../Components/formElements/MultiselectFieldHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import UpdateRemarksModal from "./UpdateRemarksModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";

const MaterialHBModal = React.forwardRef((props, ref) => {
  const message = {
    FILL_REQUIRED_FIELD: "Please fill the required field",
  };

  let materialNr = useSelector(
    (state) => state?.customerV1?.material?.materialNr,
  );

  const dispatch = useDispatch();

  const fallbackOthers = [{ id: 1, name: "Others", code: "OTHERS", description: "Others" }];

  const groupComboList = props.groupComboList?.length ? props.groupComboList : fallbackOthers;

  const buildingTypes = [
    { id: 1, name: "CS", code: "CS", discription: "CS" },
    { id: 2, name: "MS", code: "MS", discription: "MS" },
    { id: 3, name: "MG", code: "MG", discription: "MG" },
  ];

  const emptyForm = {
    materialAttachments: "",
    materialImage: "",
    materialCode: "",
    materialDescription: "",
    materialGroup: "",
    average: "",
    quntity: "",
    pieceMeasure: "",
    unit: "",
    unitWeight: "",
    unitPrice: "",
    unitWeightModifier: "",
    unitPriceModifier: "",
    surfacePaintArea: "",
    remarks: "",
    weightPice: "",
    weightTotal: "",
    bookPrice: "",
    bookTotalPrice: "",
    materialCategory: "",
    materialCategoryCode: "",
    materialCategoryDesc: "",
    materialSubCategory: "",
    materialSubCategoryCode: "",
    materialSubCategoryDesc: "",
    materialGroupCode: "",
    materialGroupDesc: "",
    buildingType: [],
    version: "V0",
  };

  const [formInputs, setFormInputs] = useState({ ...emptyForm });
  const failureModalData = { title: "Warning", ErrorMsg: "" };

  const [validation, setValidation] = useState({});
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureModal] = useState();
  const [disabled, setDisabled] = useState("");
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [materialMode, setMaterialMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [webplate, setWebPlate] = useState({});
  const [getDropdownData, setDropdownData] = useState("");
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [updateModalShow, setUpdateModalShow] = useState(false);
  //eslint-disable-next-line
  const [getBuildingType, setBuildingType] = useState();
  const [getOldUnitPrice, setOldUnitPrice] = useState();
  // eslint-disable-next-line
  const prevBuildingTypeRef = useRef();
  // eslint-disable-next-line
  const [fileDeleted, setFileDeleted] = useState(false);

const filteredCategoryComboList = useMemo(() => {
    const allData = props.allMaterialData || [];
    const selectedGroupCode = webplate?.materialGroupCode;

    // No group selected → show nothing (empty + Others only)
    if (!selectedGroupCode) {
      return fallbackOthers;
    }

    // "OTHERS" selected → free-text, no dropdown needed
    if (selectedGroupCode === "OTHERS") {
      return fallbackOthers;
    }

    const seen = new Set();
    const list = [];
    allData.forEach((d) => {
      if (
        d.materialGroupCode === selectedGroupCode &&
        d.materialCategory &&
        d.materialCategoryCode &&
        !seen.has(d.materialCategoryCode)
      ) {
        seen.add(d.materialCategoryCode);
        list.push({
          id: list.length + 1,
          name: d.materialCategory,
          code: d.materialCategoryCode,
          description: d.materialCategoryDesc || d.materialCategory,
        });
      }
    });
    list.push({ id: list.length + 1, name: "Others", code: "OTHERS", description: "Others" });

    //  STRICT: Only return filtered list (no fallback to full list)
    // If no categories found for this group, show just Others
    return list;
    // eslint-disable-next-line
  }, [webplate?.materialGroupCode, props.allMaterialData]);
  //eslint-disable-next-line
const filteredSubCategoryComboList = useMemo(() => {
    const allData = props.allMaterialData || [];
    const selectedCategoryCode = webplate?.materialCategoryCode;

    // No category selected → show nothing (Others only)
    if (!selectedCategoryCode) {
      return fallbackOthers;
    }

    // "OTHERS" selected → free-text
    if (selectedCategoryCode === "OTHERS") {
      return fallbackOthers;
    }

    const seen = new Set();
    const list = [];
    allData.forEach((d) => {
      if (
        d.materialCategoryCode === selectedCategoryCode &&
        d.materialSubCategory &&
        d.materialSubCategoryCode &&
        !seen.has(d.materialSubCategoryCode)
      ) {
        seen.add(d.materialSubCategoryCode);
        list.push({
          id: list.length + 1,
          name: d.materialSubCategory,
          code: d.materialSubCategoryCode,
          description: d.materialSubCategoryDesc || d.materialSubCategory,
        });
      }
    });
    list.push({ id: list.length + 1, name: "Others", code: "OTHERS", description: "Others" });

    //  STRICT: Only return filtered list (no fallback to full list)
    return list;
    // eslint-disable-next-line
  }, [webplate?.materialCategoryCode, props.allMaterialData]);
  
  // ── Mode setup ────────────────────────────────────────────────────
  useEffect(() => {
    if (props?.show === "CREATE") {
      setFormInputs({ ...emptyForm });
      setWebPlate({});
      setMaterialMode(false);
    } else if (props?.show === "EDIT") {
      setMaterialMode(false);
    } else if (props?.show === "DETAILS") {
      setMaterialMode(true);
    } else {
      setMaterialMode(true);
    }
    // eslint-disable-next-line
  }, [props?.show]);

  const toggleCardVisibility1 = () => setCardVisible1(!isCardVisible1);
  const hideFailureModal = () => setShowFailureModal(false);

  const handleAttachmentDeleted = ({ hasFiles }) => {
    if (!hasFiles) {
      setFormInputs((prev) => ({ ...prev, supportingDoc: "" }));
      setFileDeleted(true);
    }
  };

  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape" || e.keyCode === 27) props.onHide();
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  }, [props]);

  // ── Input change with auto-calculations ──────────────────────────
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((prev) => {
      const formattedValue =
        name === "materialCode" || name === "materialDescription"
          ? value.toUpperCase() : value;
      const updated = { ...prev, [name]: formattedValue };

      const pieceMeasure       = parseFloat(updated.pieceMeasure)       || 0;
      const unitWeight         = parseFloat(updated.unitWeight)         || 0;
      const unitWeightModifier = parseFloat(updated.unitWeightModifier) || 0;
      const unitPrice          = parseFloat(updated.unitPrice)          || 0;
      const unitPriceModifier  = parseFloat(updated.unitPriceModifier)  || 0;
      const quantity           = parseFloat(updated.quntity)            || 0;
      const round3 = (n) => Math.round(n * 1000) / 1000;

      const weightPice    = round3(pieceMeasure * unitWeight * unitWeightModifier);
      const bookPrice     = round3(pieceMeasure * unitPrice * unitPriceModifier);

      return {
        ...updated,
        weightPice,
        weightTotal:    round3(weightPice * quantity),
        bookPrice,
        bookTotalPrice: round3(bookPrice * quantity),
      };
    });
    setValidation((prev) => ({ ...prev, [name]: "" }));
  };

  // ── Load EDIT / DETAILS ───────────────────────────────────────────
  useEffect(() => {
    if ((props?.show === "EDIT" || props?.show === "DETAILS") && materialNr) {
      setLoading(true);
      ItemService.generateCustomerQueryHb({
        queryName: "Get_MATERIAL_DETAIL",
        documentNumber: materialNr,
      })
        .then((res) => {
          if (res?.data?.length) {
            const data = res.data[0];
            setOldUnitPrice(data?.unitPrice);

            let processedData = { ...data };
            if (typeof data.buildingType === "string") {
              processedData.buildingType = data.buildingType
                ? data.buildingType.split(",").filter((i) => i.trim()) : [];
            } else if (!data.buildingType) {
              processedData.buildingType = [];
            }

            setFormInputs({
              ...processedData,
              version: processedData.version || "V0",
              updateRemarks: processedData.updateRemarks || [],
            });

            if (processedData.buildingType?.length) {
              setBuildingType({
                buildingType: buildingTypes.filter((bt) =>
                  processedData.buildingType.includes(bt.code)
                ),
              });
            }

            setWebPlate({
              materialGroup:           data?.materialGroup           || "",
              materialGroupCode:       data?.materialGroupCode       || "",
              materialGroupDesc:       data?.materialGroupDesc       || "",
              materialCategory:        data?.materialCategory        || "",
              materialCategoryCode:    data?.materialCategoryCode    || "",
              materialCategoryDesc:    data?.materialCategoryDesc    || "",
              materialSubCategory:     data?.materialSubCategory     || "",
              materialSubCategoryCode: data?.materialSubCategoryCode || "",
              materialSubCategoryDesc: data?.materialSubCategoryDesc || "",
            });
          }
        })
        .catch(() => toast.error("Failed to fetch material details!"))
        .finally(() => setLoading(false));
    }
    // eslint-disable-next-line
  }, [props?.show, materialNr]);

  // ── handleInputChange (thickness / webPlate dims) ─────────────────
  const handleInputChange = (field, value) => {
    setFormInputs((prev) => {
      const updated = { ...prev, [field]: value };
      const { thickNess, webPlateX, webPlateY } = updated;

      // const materialGroupValue =
      //   webplate?.materialGroupCode === "OTHERS"
      //     ? prev?.materialGroup : webplate?.materialGroup;
      const materialGroupValue =
  webplate?.materialCategoryCode === "OTHERS"
    ? prev?.materialCategory
    : webplate?.materialCategory;

      if (materialGroupValue && materialGroupValue !== "OTHERS") {
        let desc = materialGroupValue;
        if (thickNess) desc += ` ${thickNess}MM`;
        if (webPlateX && webPlateY)  desc += ` (${webPlateX}-${webPlateY})`;
        else if (webPlateX)          desc += ` (${webPlateX})`;
        else if (webPlateY)          desc += ` (${webPlateY})`;
        updated.materialDescription = desc;
      }
      return updated;
    });
  };

  // ── Dropdown handler (memoised) ───────────────────────────────────
  const handleDropdownData = useCallback((data) => {
    setDropdownData((prev) =>
      JSON.stringify(prev) === JSON.stringify(data) ? prev : data
    );
  }, []);

  // ── React to dropdown selections ──────────────────────────────────
  useEffect(() => {
    if (!getDropdownData?.textField) return;
    const field = getDropdownData.textField;

    if (field === "materialGroup") {
      // ✅ Reset category & subCategory when group changes
      setWebPlate({
        materialGroup:           getDropdownData?.name,
        materialGroupCode:       getDropdownData?.code,
        materialGroupDesc:       getDropdownData?.description,
        materialCategory:        "",
        materialCategoryCode:    "",
        materialCategoryDesc:    "",
        materialSubCategory:     "",
        materialSubCategoryCode: "",
        materialSubCategoryDesc: "",
      });
      setFormInputs((prev) => ({
        ...prev,
        materialCategory:        "",
        materialCategoryCode:    "",
        materialCategoryDesc:    "",
        materialSubCategory:     "",
        materialSubCategoryCode: "",
        materialSubCategoryDesc: "",
      }));
    } else if (field === "materialCategory") {
      // ✅ Reset subCategory when category changes
      setWebPlate((prev) => ({
        ...prev,
        materialCategory:        getDropdownData.name,
        materialCategoryCode:    getDropdownData.code,
        materialCategoryDesc:    getDropdownData.description,
        materialSubCategory:     "",
        materialSubCategoryCode: "",
        materialSubCategoryDesc: "",
      }));
      setFormInputs((prev) => ({
        ...prev,
        materialSubCategory:     "",
        materialSubCategoryCode: "",
        materialSubCategoryDesc: "",
      }));
    } else if (field === "materialSubCategory") {
      setWebPlate((prev) => ({
        ...prev,
        materialSubCategory:     getDropdownData.name,
        materialSubCategoryCode: getDropdownData.code,
        materialSubCategoryDesc: getDropdownData.description,
      }));
    } else if (field === "buildingType") {
      const selectedArray = getDropdownData?.selected || [];
      setBuildingType({ buildingType: selectedArray });
      const codes = selectedArray.map((i) =>
        typeof i === "object" ? i?.code : i
      );
      setFormInputs((prev) => {
        const oldCodes = [...(Array.isArray(prev.buildingType) ? prev.buildingType : [])].sort();
        const newCodes = [...codes].sort();
        const changed =
          newCodes.length !== oldCodes.length ||
          newCodes.some((c, idx) => c !== oldCodes[idx]);
        return changed ? { ...prev, buildingType: codes } : prev;
      });
    }
  }, [getDropdownData]);

  // ── Auto-generate materialDescription ─────────────────────────────
  useEffect(() => {
    // const materialGroupValue =
    //   webplate?.materialGroupCode === "OTHERS"
    //     ? formInputs?.materialGroup : webplate?.materialGroup;
    const materialGroupValue =
  webplate?.materialCategoryCode === "OTHERS"
    ? formInputs?.materialCategory
    : webplate?.materialCategory;
    if (!materialGroupValue) return;

    setFormInputs((prev) => {
      const { thickNess, webPlateX, webPlateY } = prev;
      let desc = materialGroupValue;
      if (thickNess) desc += ` ${thickNess}MM`;
      if (webPlateX && webPlateY) desc += ` (${webPlateX}-${webPlateY})`;
      else if (webPlateX)         desc += ` (${webPlateX})`;
      else if (webPlateY)         desc += ` (${webPlateY})`;
      return { ...prev, materialDescription: desc };
    });
    // eslint-disable-next-line
  }, [webplate, formInputs?.materialGroup]);

  // ── "Others" free-text handlers ───────────────────────────────────
  const handleOthersInputChange = (field, value) => {
    const upperValue = value.toUpperCase();
    setFormInputs((prev) => ({
      ...prev,
      [field]:          upperValue,
      [`${field}Code`]: upperValue.slice(0, 6).replace(/\s/g, ""),
      [`${field}Desc`]: upperValue,
    }));
    setWebPlate((prev) => ({ ...prev, [`${field}Code`]: "OTHERS" }));
  };

  const handleResetToCombobox = (field) => {
    setWebPlate((prev) => ({
      ...prev, [field]: "", [`${field}Code`]: "", [`${field}Desc`]: "",
    }));
    setFormInputs((prev) => ({
      ...prev, [field]: "", [`${field}Code`]: "", [`${field}Desc`]: "",
    }));
  };

  // ── Duplication check ─────────────────────────────────────────────
  const handleCheckValidation = async ({ target: { name, value } }) => {
    if (!value || name !== "materialCode") return false;
    try {
      const item = await ItemService.generateCustomerQueryHb({
        queryName: "Check_Material_Duplication",
        materialCode: value,
      });
      const errorMsg =
        item?.status === 200 &&
        item?.data?.length > 0 &&
        item.data[0].isItDuplicate === "true"
          ? "This Material Code already exists." : "";
      setValidation((prev) => ({ ...prev, [name]: errorMsg }));
      return !!errorMsg;
    } catch {
      setValidation((prev) => ({
        ...prev, [name]: "Unable to validate. Please try again.",
      }));
      return true;
    }
  };

  // ── Build final payload ───────────────────────────────────────────
  const buildPayload = () => {
    const isGroupOthers       = webplate?.materialGroupCode       === "OTHERS";
    const isCategoryOthers    = webplate?.materialCategoryCode    === "OTHERS";
    const isSubCategoryOthers = webplate?.materialSubCategoryCode === "OTHERS";

    const thickNessInMeter = parseFloat(formInputs?.thickNess) / 1000 || 0;
    const webPlateXInMeter = parseFloat(formInputs?.webPlateX) / 1000 || 0;
    const webPlateYInMeter = parseFloat(formInputs?.webPlateY) / 1000 || 0;
    const avg = (webPlateXInMeter + webPlateYInMeter) / 2 || 0;

    return {
      ...formInputs,
      thickNessInMeter, webPlateXInMeter, webPlateYInMeter, avg,
      buildingType: formInputs?.buildingType || [],

      materialGroup:     isGroupOthers       ? formInputs?.materialGroup     || "" : webplate?.materialGroup     || "",
      materialGroupCode: isGroupOthers       ? formInputs?.materialGroupCode || "" : webplate?.materialGroupCode || "",
      materialGroupDesc: isGroupOthers       ? formInputs?.materialGroupDesc || "" : webplate?.materialGroupDesc || "",

      materialCategory:     isCategoryOthers ? formInputs?.materialCategory     || "" : webplate?.materialCategory     || "",
      materialCategoryCode: isCategoryOthers ? formInputs?.materialCategoryCode || "" : webplate?.materialCategoryCode || "",
      materialCategoryDesc: isCategoryOthers ? formInputs?.materialCategoryDesc || "" : webplate?.materialCategoryDesc || "",

      materialSubCategory:     isSubCategoryOthers ? formInputs?.materialSubCategory     || "" : webplate?.materialSubCategory     || "",
      materialSubCategoryCode: isSubCategoryOthers ? formInputs?.materialSubCategoryCode || "" : webplate?.materialSubCategoryCode || "",
      materialSubCategoryDesc: isSubCategoryOthers ? formInputs?.materialSubCategoryDesc || "" : webplate?.materialSubCategoryDesc || "",
    };
  };

  // ── Validation guard ──────────────────────────────────────────────
  const runValidation = () => {
    const anyError = Object.values(validation).some((v) => v !== null && v !== "");
    if (anyError) {
      setErrorFields([message.FILL_REQUIRED_FIELD]);
      setShowFailureModal(true);
      return false;
    }
    const required = ["materialCode", "unit", "unitWeight", "unitPrice", "remarks"];
    for (const key of required) {
      if (!validateRequired(formInputs[key])) {
        setValidation((prev) => ({ ...prev, [key]: message.FILL_REQUIRED_FIELD }));
        return false;
      }
    }
    return true;
  };

  const resetForm = () => { setFormInputs({ ...emptyForm }); setWebPlate({}); };
  const refreshList = () => dispatch(getMaterialList({ queryName: "Get_MATERIAL_LIST", page: 1, per_page: 10 }));

  // ── Submit (CREATE) ───────────────────────────────────────────────
  const handleSubmit = async () => {
    if (!runValidation()) return;
    setDisabled(true);
    await ItemService.addMaterialHb({ data: buildPayload() }).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Saved successfully", { duration: 2000, position: "top-right" });
        props.onHide(); resetForm(); refreshList();
      } else {
        toast.error(item?.message || "Please try again !!", { duration: 4000, position: "top-right" });
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  // ── Update (EDIT) ─────────────────────────────────────────────────
  const handleUpdate = async (newRemarks, newVersion) => {
    setDisabled(true);
    await ItemService.updateMaterialHb({ ...buildPayload(), updateRemarks: newRemarks, version: newVersion }).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Updated successfully", { duration: 2000, position: "top-right" });
        props.onHide(); resetForm(); refreshList();
      } else {
        toast.error(item?.message || "Please try again !!", { duration: 4000, position: "top-right" });
      }
      setDisabled(false);
    });
    toast.dismiss("");
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((prev) => ({ ...prev, [data.fieldName]: data.attachmentId }));
  };

  const handleViewFile = (id) => { setFileViewData(id); setShowFileViewModal(true); };
  const handleViewFileHide = () => setShowFileViewModal(false);

  const showApproveModal = () => setUpdateModalShow(true);
  const updateHideModal  = () => setUpdateModalShow(false);

  const handleValueChange = (remarks) => {
    const incV = (v) => {
      if (!v) return "V1";
      const n = parseInt(v.replace("V", ""), 10);
      return isNaN(n) ? "V1" : `V${n + 1}`;
    };
    const newVersion = incV(formInputs.version);
    const newRemarks = [
      ...(formInputs.updateRemarks || []),
      { remark: remarks, version: newVersion, unitPriceold: getOldUnitPrice, unitPriceNew: formInputs?.unitPrice, updateAtDateTime: new Date().toISOString() },
    ];
    setFormInputs((prev) => ({ ...prev, updateRemarks: newRemarks, version: newVersion }));
    setOldUnitPrice(formInputs?.unitPrice);
    handleUpdate(newRemarks, newVersion);
  };

  const remarkLineItemColInfo = [
    { name: "Update At",      cell: (row) => <span>{formatDateWithAMPM(row?.updateAtDateTime) || ""}</span>, width: "180px" },
    { name: "Version",        cell: (row) => <span>{row?.version      || ""}</span>, width: "120px" },
    { name: "Old Unit Price", cell: (row) => <span>{row?.unitPriceold || ""}</span>, width: "130px" },
    { name: "New Unit Price", cell: (row) => <span>{row?.unitPriceNew || ""}</span>, width: "130px" },
    { name: "Remarks",        cell: (row) => <span>{row?.remark       || ""}</span>, width: "120px" },
  ];

  const remarkItemShowModal = (data) => {
    setItemLevelData(data); setItemLevelColumns(remarkLineItemColInfo);
    setModalTitle("Remarks / Version"); setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => setItemLevelModalShow(false);

  useEffect(() => { return () => setDropdownData(null); }, []);

  // ── Reusable combo/input toggle ───────────────────────────────────
  const renderComboOrInput = (fieldKey, label, comboData, codeKey, descKey) => {
    const isOthers = webplate?.[codeKey] === "OTHERS";
    return (
      <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
        {isOthers ? (
          <>
            {!materialMode && (
              <span
                style={{ cursor: "pointer", color: "blue", fontSize: "12px" }}
                onClick={() => handleResetToCombobox(fieldKey)}
              >
                ↩ Reset to Dropdown
              </span>
            )}
            <InputField
              label={`${label} *`} id={fieldKey} className="inputBox"
              name={fieldKey} type="text"
              value={formInputs?.[fieldKey] || ""}
              onChange={(e) => handleOthersInputChange(fieldKey, e.target.value)}
              disabled={materialMode} error={validation?.[fieldKey]}
            />
          </>
        ) : (
          <ComboboxField
            className="inputBox" label={label} placeholder=""
            data={comboData} name={fieldKey} code={codeKey} description={descKey}
            setValue={webplate?.[fieldKey] || formInputs?.[fieldKey] || ""}
            getvalue={handleDropdownData} disabled={materialMode}
          />
        )}
      </Col>
    );
  };

  return (
    <>
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false} size="xl" ref={ref} centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {props?.show === "CREATE" ? "Create Material"
              : props?.show === "DETAILS" ? "Material Detail"
              : props?.show === "EDIT"    ? "Edit Material" : ""}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <>
              <div className="commLeftRightPadding d-flex align-items-end mb-4">
                {props?.show !== "DETAILS" && (
                  <Col xs={12} md={4} lg={4} className="commLeftRightPadding">
                    <FileUploadComponentForHB
                      id="materialImage" name="materialImage" label="Material Image"
                      allowedTypes={["image/png", "image/jpeg"]}
                      multiple={false} required={true}
                      onSuccessUpload={onSuccessUploadDocumentType}
                      value={formInputs?.materialImage || ""}
                    />
                  </Col>
                )}
                <Col xs={12} md={4} lg={4} className="commLeftRightPadding d-flex justify-content-center align-items-center">
                  <ShowUploadImage fileid={formInputs?.materialImage} />
                </Col>
              </div>

              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i className={`bi ${isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"}`} onClick={toggleCardVisibility1} />
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BI</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Basic Information</span>
                        <span className="subHeaderTitle">Basic Information</span>
                      </Col>
                    </Row>
                  </h2>

                  <div className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""}`}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4 d-flex align-items-center">

                        {/* Material Code */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <InputField
                            placeholder="" className="inputBox" label="Material Code"
                            id="materialCode" name="materialCode" type="text"
                            value={formInputs?.materialCode || ""}
                            onChange={onInputChange} onBlur={handleCheckValidation}
                            disabled={props?.show === "EDIT" || props?.show === "DETAILS"}
                            error={validation?.materialCode}
                          />
                        </Col>

                        {/* ✅ Material Group — DB groups */}
                        {renderComboOrInput("materialGroup", "Material Group", groupComboList, "materialGroupCode", "materialGroupDesc")}

                        {/* ✅ Material Category — filtered by selected group */}
                        {renderComboOrInput("materialCategory", "Material Category", filteredCategoryComboList, "materialCategoryCode", "materialCategoryDesc")}

                        {/* ✅ Material Sub Category — filtered by selected category */}
                        {/* {renderComboOrInput("materialSubCategory", "Material Sub Category", filteredSubCategoryComboList, "materialSubCategoryCode", "materialSubCategoryDesc")} */}

                        {/* Thickness */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <InputField
                            label="Thick Ness in MM" id="thickNess" className="inputBox"
                            name="thickNess" type="number" value={formInputs?.thickNess || ""}
                            onChange={(e) => handleInputChange("thickNess", e.target.value)}
                            disabled={materialMode} error={validation?.thickNess}
                          />
                        </Col>

                        {/* Material Description */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <InputField
                            placeholder="" className="inputBox" label="Material Description"
                            id="materialDescription" name="materialDescription" type="text"
                            value={formInputs?.materialDescription || ""}
                            onChange={onInputChange}
                            disabled={
                              ["HB", "APSHSX"].includes(webplate?.materialGroup || formInputs?.materialGroup)
                                ? materialMode : true
                            }
                            error={validation?.materialDescription}
                          />
                        </Col>

                        {/* Building Type */}
                        {/* <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                          <MultiselectFieldHB
                            label="Building Type" placeholder="Please select the building Type"
                            data={buildingTypes} id="buildingType" iconClassName="dropdownIcon"
                            name="buildingType" getvalue={handleDropdownData}
                            setValue={formInputs?.buildingType || []} className="dropdownOption"
                          />
                        </Col> */}

                        {/* Unit */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <InputField
                            placeholder="" className="inputBox" label="Unit"
                            id="unit" name="unit" type="text" value={formInputs?.unit || ""}
                            onChange={onInputChange} disabled={materialMode} error={validation?.unit}
                          />
                        </Col>

                        {/* Unit Weight */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <InputField
                            placeholder="" className="inputBox" label="Unit Weight"
                            id="unitWeight" name="unitWeight" type="text" value={formInputs?.unitWeight || ""}
                            onChange={onInputChange} disabled={materialMode} error={validation?.unitWeight}
                          />
                        </Col>

                        {/* Unit Price */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <InputField
                            placeholder="" className="inputBox" label="Unit Price"
                            id="unitPrice" name="unitPrice" type="text" value={formInputs?.unitPrice || ""}
                            onChange={onInputChange} disabled={materialMode} error={validation?.unitPrice}
                          />
                        </Col>

                        {/* Remarks */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <TextAreaField
                            placeholder="" className="inputBox" label="Remarks"
                            id="remarks" name="remarks" value={formInputs?.remarks || ""}
                            onChange={onInputChange} disabled={materialMode} error={validation?.remarks}
                          />
                        </Col>

                        {/* Attachments */}
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          <FileUploadComponentForHB
                            id="materialAttachments" name="materialAttachments" label="Material Attachments"
                            allowedTypes={["image/png","image/jpeg","application/pdf",".dwg"]}
                            multiple={true} onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.materialAttachments || ""} error={validation?.materialAttachments}
                          />
                        </Col>
                        <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                          {formInputs?.materialAttachments && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon" alt="attachments"
                              onClick={() => handleViewFile(formInputs?.materialAttachments)}
                            />
                          )}
                        </Col>

                        {/* Version tracker */}
                        <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                          <span className="fw-medium text-black">Remarks / Version</span>
                          <div>
                            <span style={{ marginLeft: "12px" }} onClick={() => remarkItemShowModal(formInputs.updateRemarks)}>
                              <i className="bi bi-calendar2-week iconTable" />
                            </span>
                            <span className="suppliersIcon">
                              {formInputs?.updateRemarks?.length > 0
                                ? `${formInputs.updateRemarks.length}/${formInputs?.version}`
                                : `0/${formInputs?.version}`}
                            </span>
                          </div>
                        </Col>
                        <Col xs={12} md={12} lg={12} />
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {props.show !== "DETAILS" && (
                <div className="space-y-4">
                  <Row className="justify-end">
                    <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                      <button type="button" onClick={() => props.onHide()}
                        className="btn btn-danger mt-4 w-full justify-center rounded-md">
                        Cancel
                      </button>
                    </Col>
                    {props.show === "CREATE" && (
                      <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                        <button onClick={handleSubmit} disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md">
                          Save
                        </button>
                      </Col>
                    )}
                    {props.show === "EDIT" && (
                      <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
                        <button onClick={() => showApproveModal("Update")} disabled={disabled}
                          className="btn btn-primary mt-4 w-full justify-center rounded-md">
                          Update
                        </button>
                      </Col>
                    )}
                  </Row>
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      <FileViewerModalForHB show={getShowFileViewModal} onHide={handleViewFileHide} fileid={getFileViewData} onDeleteSuccess={handleAttachmentDeleted} />
      <FileViewerModalForHB show={getShowFailureModal} onHide={hideFailureModal} failuremodaldata={failureModalData} requiredfields={getErrorFields} onDeleteSuccess={handleAttachmentDeleted} />
      <UpdateRemarksModal show={updateModalShow} onHide={updateHideModal} onvaluechange={handleValueChange} />
      <CommonItemLevelDatatableModal show={itemLevelModalShow} onHide={itemLevelHideModal} columns={getItemLevelColumns} data={getItemLevelData} title={getModalTitle} />
    </>
  );
});

export default MaterialHBModal;
